import {
  COLOR,
  COMBINED_LEVELS_FILTER,
  COUNTRY,
  NO_TOKEN,
  NOT_AVAILABLE,
  STATE_CODE_NAME,
  TABLE_SORT_ASC,
} from "./Constants.tsx";
import { ColumnHeaderType } from "./Types";
import L from "leaflet";
import moment from "moment";
import { DATE_FORMAT } from "./Constants.tsx";
import { CLAIMS_CATEGORY_KEY_MAP } from "./Constants.tsx";
// Season & Dates function
export const getSeasonDateRange = (formData: any, seasons: any) => {
  if (formData?.year && formData?.season) {
    const year = parseInt(formData.year);
    // now season is multi selection, if more than one seasons are selected the date filter will be disabled.
    if (!formData?.season || formData?.season?.length > 1 || !year) {
      return null;
    }
    let startDate = "";
    let endDate = "";
    const selectedSeason = seasons?.filter(
      (item) => formData.season[0]?.value === item?.seasonid
    );
    const startMonth = selectedSeason[0]?.startmonth;
    const endMonth = selectedSeason[0]?.endmonth;
    

    
const isLeapYear = (y) => ((y % 4 === 0 && y % 100 !== 0) || y % 400 === 0);

const nextYear = year + 1;
const leapNextYear = isLeapYear(nextYear);

switch (((selectedSeason[0]?.seasonname) || "").toLowerCase()) {
  case "kharif":
    startDate = `01-${startMonth}-${year}`;
    endDate = `30-${endMonth}-${year}`;
    break;

  case "rabi":
    
    startDate = `01-${startMonth}-${year}`;
    endDate = `${leapNextYear ? 29 : 28}-${endMonth}-${nextYear}`;
    break;

  case "summer":
    startDate = `01-${startMonth}-${year}`;
    endDate = `30-${endMonth}-${year}`;
    break;

  case "annual":
    startDate = `01-${startMonth}-${year}`;
    endDate = `31-${endMonth}-${year}`;
    break;

  default:
    return null;
}


    return {
      minDate: startDate,
      maxDate: endDate,
      stateStartDate: startDate,
      stateEndDate: endDate,
    };
  }

  if (!formData?.year) {
    const defaultStart = moment()
      .subtract(1, "days")
      .format(DATE_FORMAT.DD_MM_YYYY);
    const defaultEnd = moment().format(DATE_FORMAT.DD_MM_YYYY);
    return {
      minDate: null,
      maxDate: moment().toDate(),
      stateStartDate: defaultStart,
      stateEndDate: defaultEnd,
    };
  }

  return null;
};

export const findValue = (headerItem: ColumnHeaderType, item: any) => {
  if (headerItem.valueGetter) {
    return headerItem.valueGetter(item, headerItem.field) ?? NOT_AVAILABLE;
  } else if (headerItem.value) {
    return headerItem.value ?? NOT_AVAILABLE;
  } else {
    return item[headerItem.field] ?? NOT_AVAILABLE;
  }
};

export const blankValueGetter = (data: any, field?: string) => {
  
  
  return checkNullValue(data[field as keyof any]);
};



export const valueWithDecimalPlace = (data: any, field?: string) => {
  const value = data[field as keyof any];
  if (value === 0) {
    return 0;
  }
  if (!isValidString(value)) {
    return NOT_AVAILABLE;
  }
  return Number(value).toFixed(2);
};
export const checkNullValue = (value?: string | number) => {
  if (!isValidString(value)) {
    return NOT_AVAILABLE;
  }
  return value;
};

export const isValidString = (value?: string | number) => {
  if (!value || value === "null" || value === "undefined") {
    return false;
  } else if (String(value).replaceAll(" ", "").length === 0) {
    return false;
  }
  return true;
};

export const getMarkers = (
  markerType: string,
  item: any
): L.LatLng | undefined => {
  if (!item?.latitude || !item?.longitude) {
    return undefined;
  }
  switch (markerType) {
    case "posps":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/posps.svg").default,
      };
    case "universities":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/universities.svg").default,
      };
    case "policies":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/policies.svg").default,
      };
    case "crops":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/crops.svg").default,
      };
    case "customers":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/customers.svg").default,
      };
    case "premium":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/premium.svg").default,
      };
    case "suminsured":
      return {
        position: L.latLng(
          parseFloat(item?.latitude),
          parseFloat(item?.longitude)
        ),
        icon: require("../assets/images/sum_insured.svg").default,
      };
    default:
      return undefined;
  }
};

export const formatNumber = (
  value: number | string | undefined,
  decimal?: number
) => {
  if (!value) {
    return value;
  }
  let num = Number(value || 0);
  if (num < 1000) {
    if (decimal) {
      return Number(num).toFixed(decimal);
    } else {
      return num.toString();
    }
  } else if (num >= 1000 && num < 100000) {
    return (num / 1000).toFixed(2) + "K";
  } else if (num >= 100000 && num < 10000000) {
    return (num / 100000).toFixed(2) + "L";
  } else if (num >= 10000000 && num < 1000000000) {
    return (num / 10000000).toFixed(2) + "CR";
  } else if (num >= 1000000000) {
    return (num / 10000000).toFixed(2) + "CR";
  }
};
export const getValueForMap = (value) => {
  if (!value) {
    return "";
  }
  if (Number(value) === value && value % 1 === 0) {
    return formatNumber(value);
  } else {
    return formatNumber(value, 2);
  }
};

export const getCountryRangeValue = (filterName: string, legendValues: any) => {
  const formatRangeValue = (minKey: string, maxKey: string) => ({
    minValue: formatNumber(legendValues?.[minKey]),
    maxValue: formatNumber(legendValues?.[maxKey]),
    minColor: COLOR.country.min,
    maxColor: COLOR.country.max,
  });

  switch (filterName) {
    case "Premium":
      return formatRangeValue("min_premium", "max_premium");
    case "Sum Insured":
      return formatRangeValue("min_suminsured", "max_suminsured");
    case "Policies":
      return formatRangeValue("min_policies", "max_policies");
    case "POSPs":
      return formatRangeValue("min_posps", "max_posps");
    case "Area":
      return formatRangeValue("min_area", "max_area");
    default:
      return { minValue: "", maxValue: "", minColor: "", maxColor: "" };
  }
};

export const getPosition = (polygon: string) => {
  let latLngArray: any[] = [];
  if (!polygon) {
    return latLngArray;
  }
  let text;
  polygon = polygon.trim();
  if (polygon.includes("MULTIPOLYGON")) {
    text = polygon.replace("MULTIPOLYGON(((", "");
    text = text.replace(")))", "");
  } else if (polygon.includes("POLYGON")) {
    text = polygon.replace("POLYGON((", "");
    text = text.replace("))", "");
  }
  const array = text.split(",");
  latLngArray = array[0]?.split(" ");
  return latLngArray;
};
export const selectedFilterClass = (
  data: any,
  field?: any,
  filter?: string
) => {
  field = field.replace("_", " ");
  if (
    filter &&
    filter?.replace(" ", "")?.toLowerCase() ===
      field?.replace(" ", "")?.toLowerCase()
  ) {
    return "bold-value";
  } else {
    return "";
  }
};

export const numberFormatWithCurrency = (amount: number | string) => {
  if (amount || amount === 0) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(Number(Number(amount).toFixed(2)));
  } else {
    return NOT_AVAILABLE;
  }
};

export const numberCurrencyFormatInTable = (data: any, field?: any) => {
  return numberFormatWithCurrency(data[field]);
};

export const numberWithoutCurrencyFormatInTable = (data: any, field?: any) => {
  return numberFormatWithoutCurrency(Number(data[field] || 0), 2);
};

export const numberFormatWithoutCurrency = (
  value: number | string,
  toFixed?: number
) => {
  if (value === 0) {
    return value;
  }
  if (value) {
    const decimal = toFixed || toFixed === 0 ? toFixed : 2;
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
    }).format(Number(Number(value || 0).toFixed(decimal)));
  } else {
    return NOT_AVAILABLE;
  }
};

export const numberFormat = (data: any, field?: any) => {
  const amount = data[field];
  let decimalAmount = amount;
  if (amount || amount === 0) {
    if (!Number.isInteger(amount)) {
      decimalAmount = Number(amount).toFixed(2);
    }
    let text = Number(decimalAmount).toLocaleString("en-IN");
    return text;
  } else {
    return NOT_AVAILABLE;
  }
};

export const arrayToString = (data: any, field?: any) => {
  const array = data[field];
  if (!array || !array?.length) {
    return NOT_AVAILABLE;
  }
  return array.join(", ");
};

export const getDataWithKeyValue = (
  list: any,
  keyName: string,
  itemName: string
) => {
  if (itemName === "country") return "";
  const foundData = list?.find((item: any) => item[keyName] === itemName);
  return foundData;
};
// Convert RGB to hex
const rgbToHex = (r, g, b) => {
  return (
    "#" +
    ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()
  );
};
// Convert hex color codes to RGB
const hexToRgb = (hex) => {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
};
export const getColorCode = (value, minValue, maxValue, minColor, maxColor) => {
  // Normalize value between 0 and 1
  const normalizedValue = (value - minValue) / (maxValue - minValue);

  // Ensure value stays within bounds
  const clampedValue = Math.min(Math.max(normalizedValue, 0), 1);

  // Convert minColor and maxColor to RGB
  const minRgb = hexToRgb(minColor);
  const maxRgb = hexToRgb(maxColor);

  // Calculate the RGB values for the result color
  const r = Math.round(minRgb.r + (maxRgb.r - minRgb.r) * clampedValue);
  const g = Math.round(minRgb.g + (maxRgb.g - minRgb.g) * clampedValue);
  const b = Math.round(minRgb.b + (maxRgb.b - minRgb.b) * clampedValue);

  // Convert the resulting RGB color back to hex and return it
  return rgbToHex(r, g, b);
};

export const getIdWiseData = (countryTableData, styleView) => {
  const result = countryTableData?.reduce((acc, item) => {
    acc[item.sid] = { ...item, styleView };
    return acc;
  }, {});
  return result;
};

export const nameValueGetter = (data: any, field?: string) => {
  if (data["first_name"] && data["last_name"]) {
    return `${data["first_name"]} ${data["last_name"]}`;
  } else if (data["first_name"]) {
    return data["first_name"];
  } else if (data["last_name"]) {
    return data["last_name"];
  } else {
    return "";
  }
};

export const getPOSPSName = (pospDetails) => {
  if (!pospDetails || pospDetails.length === 0) return "";

  return pospDetails
    .map((POSP, index) => {
      const POSPName = nameValueGetter(POSP);
      return (
        POSPName &&
        (index === pospDetails.length - 2 ? POSPName + ", " : POSPName)
      );
    })
    .filter(Boolean);
};

export const isSimpleMarker = (marker: string) => {
  if (marker === "premium" || marker === "suminsured" || marker === "area") {
    return true;
  }
  return false;
};
export const sortListItems = (
  list: any[],
  sortBy: string | null,
  sortOrder: string
) => {
  if (!sortBy) return list;
  return [...list].sort((a, b) => {
    let itemA: Number | string;
    let itemB: Number | string;
    if (isNaN(a[sortBy])) {
      itemA = a[sortBy];
    } else {
      itemA = Number(a[sortBy] || 0);
    }
    if (isNaN(b[sortBy])) {
      itemB = b[sortBy];
    } else {
      itemB = Number(b[sortBy] || 0);
    }
    if (itemA < itemB) return sortOrder === TABLE_SORT_ASC ? -1 : 1;
    if (itemA > itemB) return sortOrder === TABLE_SORT_ASC ? 1 : -1;
    return 0;
  });
};

export const setRedirect = (value) => {
  localStorage.setItem("redirect", String(value));
};
export const removeAllItemsFromLocalStorage = () => {
  localStorage.setItem("logout", "true");
  localStorage.setItem("AUTH_TOKEN", NO_TOKEN);
  localStorage.removeItem("noc");
  localStorage.removeItem("redirect");
  localStorage.removeItem("AUTH_STATUS");
  localStorage.removeItem("time");
  localStorage.removeItem("selectedState");
};
export const parseStateData = (
  dataArray,
  levelOne,
  levelTwo,
  keyValue,
  keyName
) => {
  const itemArray: any = [];
  dataArray?.forEach((element) => {
    if (
      (keyValue && String(keyValue) === String(element[keyName])) ||
      !keyValue
    ) {
      if (levelTwo === "POSP") {
        const posp_details = element?.posp_details;
        // Finding POSPs personal details
        if (element?.count) {
          posp_details?.forEach((item) => {
            itemArray.push({
              gridid: element.gridid,
              first_name: item?.first_name || NOT_AVAILABLE,
              last_name: item?.last_name || NOT_AVAILABLE,
              mobile_number: item?.mobile_number || NOT_AVAILABLE,
            });
          });
        }
      } else if (levelOne === "Claims" && levelTwo === "Customer Count") {
        itemArray.push({
          count: element?.claims_count || 0,
          gridid: element.gridid,
        });
      } else {
        itemArray.push(element);
      }
    }
  });
  return itemArray;
};

export const getRequestParams = (
  selectedFilters: any,
  productId: string | number,
  seasonArray: string[] | null,
  season_year: string | number,
  stateId: string | number,
  districtId: string | number | null,
  gridId: string | number,
  mapClickedInfo?: any
) => {
  const data: any = {};
  if (selectedFilters?.state !== COUNTRY && selectedFilters?.state !== "") {
    data.sid = stateId;
  }
  if (selectedFilters?.state !== COUNTRY && districtId) {
    data.did = districtId;
  }
  if (selectedFilters?.stateStartDate) {
    data.startdate = moment(
      selectedFilters?.stateStartDate,
      DATE_FORMAT.DD_MM_YYYY
    ).format(DATE_FORMAT.YYYY_MM_DD);
  }
  if (selectedFilters?.stateEndDate) {
    data.enddate = moment(
      selectedFilters?.stateEndDate,
      DATE_FORMAT.DD_MM_YYYY
    ).format(DATE_FORMAT.YYYY_MM_DD);
  }
  if (
    selectedFilters?.distance &&
    gridId &&
    mapClickedInfo?.lat &&
    mapClickedInfo?.lng
  ) {
    data.distance = selectedFilters.distance;
    data.lat = mapClickedInfo.lat;
    data.lon = mapClickedInfo.lng;
  }
  if (
    selectedFilters?.levelOne !== "Consolidated Business" &&
    selectedFilters?.levelOne !== "Consolidated Manpower"
  ) {
    data.level1 = selectedFilters?.levelOne;
    data.level2 = selectedFilters?.levelTwo;
    data.level3 = selectedFilters?.levelThree;
  } else {
    data.level1 = selectedFilters?.levelOne;
  }

  if (productId) {
    data.productid = productId;
  }
  if (seasonArray?.length > 0) {
    data.seasonid = `[${seasonArray}]`;
  }
  if (season_year) {
    data.season_year = season_year;
  }
  


  return data;
};

export const sumAll = (paymentArray: any) => {
  let sum = 0;
  paymentArray?.forEach((element) => {
    sum = sum + Number(element || 0);
  });
  return sum;
};


export const getThresholds = (levelOne, levelTwo, legendValues) => {
  let thresholds: any = null;
  let key = "";
  switch (levelOne + "-" + levelTwo) {
    case COMBINED_LEVELS_FILTER.POSPm_ARABLE:
      thresholds = {
        min: Number(legendValues?.min_catchment_ratio || 0),
        max: Number(legendValues?.max_catchment_ratio || 0),
      };
      key = "catchment_ratio";
      break;

    case COMBINED_LEVELS_FILTER.POSPm_TARGET:
      thresholds = {
        min: Number(legendValues?.min_target_value || 0),
        max: Number(legendValues?.max_target_value || 0),
      };
      key = "target_value";
      break;

    case COMBINED_LEVELS_FILTER.POSPm_POSP:
      thresholds = {
        min: Number(legendValues?.min_posp_count || 0),
        max: Number(legendValues?.max_posp_count || 0),
      };
      key = "count";
      break;

    case COMBINED_LEVELS_FILTER.Policy_Customer_Count:
      thresholds = {
        min: Number(legendValues?.min_customers || 0),
        max: Number(legendValues?.max_customers || 0),
      };
      key = "customer_count";
      break;

    case COMBINED_LEVELS_FILTER.Policy_Policy_Count:
      thresholds = {
        min: Number(legendValues?.min_policies || 0),
        max: Number(legendValues?.max_policies || 0),
      };
      key = "policy_count";
      break;

    case COMBINED_LEVELS_FILTER.Policy_Insured_Area:
      thresholds = {
        min: Number(legendValues?.min_area || 0),
        max: Number(legendValues?.max_area || 0),
      };
      key = "area";
      break;

    case COMBINED_LEVELS_FILTER.Policy_Sum_Insured:
      thresholds = {
        min: Number(legendValues?.min_suminsured || 0),
        max: Number(legendValues?.max_suminsured || 0),
      };
      key = "suminsured";
      break;

    case COMBINED_LEVELS_FILTER.Policy_Premium:
      thresholds = {
        min: Number(legendValues?.min_premium || 0),
        max: Number(legendValues?.max_premium || 0),
      };
      key = "premium";
      break;

    case COMBINED_LEVELS_FILTER.area:
      thresholds = {
        min: Number(legendValues?.min_area || 0),
        max: Number(legendValues?.max_area || 0),
      };
      break;

    case COMBINED_LEVELS_FILTER.Claims_Claim_Processed:
    case COMBINED_LEVELS_FILTER.Claims_Claim_Pending:
      thresholds = {
        min: Number(legendValues?.min_claim_count || 0),
        max: Number(legendValues?.max_claim_count || 0),
      };
      key = "claims_count";
      break;

    case COMBINED_LEVELS_FILTER.Claims_Amount_Disbursed:
    case COMBINED_LEVELS_FILTER.Claims_Amount_Can_Be_Disbursed:
      thresholds = {
        min: Number(legendValues?.min_payout_amount || 0),
        max: Number(legendValues?.max_payout_amount || 0),
      };
      key = "payout_amounts";
      break;

    case COMBINED_LEVELS_FILTER.Claims_Loss_Ratio:
      thresholds = {
        min: Number(legendValues?.min_loss_ratio || 0),
        max: Number(legendValues?.max_loss_ratio || 0),
      };
      key = "loss_ratio";
      break;

    case COMBINED_LEVELS_FILTER.Claims_Total_Claim_Count:
      thresholds = {
        min: Number(legendValues?.min_claim_count || 0),
        max: Number(legendValues?.max_claim_count || 0),
      };
      key = "claims_count";
      break;

    default:
      thresholds = null;
      break;
  }
  return {
    minMax: thresholds,
    key,
  };
};


export const getValueKey = (levelOne, levelTwo) => {
  let key = "";
  switch (levelOne + "-" + levelTwo) {
    case COMBINED_LEVELS_FILTER.POSPm_ARABLE:
      key = "arable_area";
      break;
    case COMBINED_LEVELS_FILTER.POSPm_TARGET:
      key = "target_value";
      break;
    case COMBINED_LEVELS_FILTER.POSPm_POSP:
      key = "count";
      break;
    case COMBINED_LEVELS_FILTER.Policy_Customer_Count:
      key = "customer_count";
      break;
    case COMBINED_LEVELS_FILTER.Policy_Policy_Count:
      key = "policy_count";
      break;
    case COMBINED_LEVELS_FILTER.Policy_Insured_Area:
      key = "area";
      break;
    case COMBINED_LEVELS_FILTER.Policy_Sum_Insured:
      key = "suminsured";
      break;
    case COMBINED_LEVELS_FILTER.Policy_Premium:
      key = "premium";
      break;
    case COMBINED_LEVELS_FILTER.area:
      break;
    case COMBINED_LEVELS_FILTER.Claims_Claim_Processed:
    case COMBINED_LEVELS_FILTER.Claims_Claim_Pending:
      key = "claims_count";
      break;
    case COMBINED_LEVELS_FILTER.Claims_Amount_Disbursed:
    case COMBINED_LEVELS_FILTER.Claims_Amount_Can_Be_Disbursed:
      key = "payout_amounts";
      break;
    case COMBINED_LEVELS_FILTER.Claims_Loss_Ratio:
      key = "loss_ratio";
      break;
    case COMBINED_LEVELS_FILTER.Claims_Total_Claim_Count:
      key = "claims_count";
      break;
  }
  return key;
};


export const stateNameGetter = (data: any, keyName?: string) => {
  if (!keyName) {
    return NOT_AVAILABLE;
  }
  return STATE_CODE_NAME[String(data[keyName])]?.name || NOT_AVAILABLE;
};

export const getInitials = (fullName) => {
  if (!fullName) {
    return NOT_AVAILABLE;
  }
  const words = fullName
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .trim()
    .split(/\s+/);
  if (words.length === 0) return "";
  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
};
